// SPDX-FileCopyrightText: 2023 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF

export type User = {
  id?: string;
  userName: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  type?: UserType;
  roles?: string[];
};

export enum UserType {
  None = 0,
  MyTrumpf = 1,
  Employee = 2,
}
